const it = {
    aftersales: {
        "contactus": "Contattaci per una risposta rapida",
        "workorder": "Elenco dei biglietti di lavoro",
        "createjob": "Crea un biglietto di lavoro",
        "submittinworkorder": "Quando invii un biglietto di lavoro, includi quante più informazioni dettagliate possibili, come schermate di errore, informazioni sull'account, ecc., che sono molto importanti per noi per risolvere rapidamente i problemi.",
        "workordercontent": "Contenuto del biglietto di lavoro",
        "subscriptionaccount": "Account di abbonamento",
        "problemtype": "Tipo di problema",
        "tobeprocessed": "in attesa di elaborazione",
        "processed": "elaborato",
        "revoked": "Revocato",
        "create": "Creare",
        "workorderno": "Numero del biglietto di lavoro",
        "product": "Prodotto",
        "status": "Stato",
        "type": "Tipo",
        "ticket": "Biglietto",
        "createtime": "Tempo di creazione",
        "reply": "rispondi",
        "operate": 'operate',
        "onlinechat":"Online Chat",
        "resolveworkorder":"We will resolve the issue as soon as you submit the work order",
        "noworkorder":"No Work Order",
        "revoke":"Revoke",
        "content":"Content"
    },
    excode: {
        "redemptioncode": "Codice di riscatto",
        "pleaseredemptioncode": "Si prega di entrare il Codice di riscatto",
        "exchange": "Scambio",
        "notused": "Non stato usato",
        "used": "Usato",
        "expired": "Scaduto",
        "status": "Stato",
        "exchangetime": "Data di scambio",
        "createtime": "Tempo di creazione",
        "selectactivityarea":"Please select the activity area",
        "optionaltraintickets":"Optional train tickets",
        "newpurchase":"New Purchase",
        "renew":"Renew"
    },
    header: {
        "personaldetails": "Personal Details"
    },
    footer: {
        "contactus": "Contattaci",
        "navigation": "Indicazione",
        "home": "Pagina iniziale",
        "friends": "Con amici",
        "subscribe": "Abbonamento",
        "aftersales": "Dopovendita",
        "help": "Aiuta",
        "termsofuse": "Termini di utilizzo",
        "refundpolicy": "Politica di rimborso",
        "privacypolicy": "Politica sulla riservatezza",
        "paymentmethod": "Metodo di pagamento",
        "language": "Lingua",
        "map":"Map",
        "homescreen":"Home Screen",
        "setpreferences":"Set Your Preferences",
        "setlanguage":"Please set your language"
    },
    friends: {
        "promotioninfo": "Informazioni di promozione",
        "currentlevel": "Livello attuale",
        "content": "Puoi utilizzare link promozionali e codici sconto esclusivi da condividere con altri per guadagnare commissioni. Più alto il livello, maggiore la quota di commissione",
        "rolemembers": "Ruolo del membro",
        "promotionallinks": "Link promozionale",
        "discountcodes": "Codice Sconto",
        "copy": "Copia",
        "rebateratio": "Il rapporto di sconto è",
        "discountratio": "Rapporto di sconto",
        "lowestdiscountratio": "Rapporto di sconto più basso",
        "walletsandpoints": "Portafogli e punti",
        "applywithdrawal": "Dopo aver richiesto il prelievo, esamineremo ed effettueremo il pagamento entro 3 giorni lavorativi",
        "withdraw": "Ritirare",
        "record": "Registrazione",
        "integral": "Punti",
        "pointsused": "I punti possono essere utilizzati per la lotteria",
        "orderdetails": "Dettagli di ordine",
        "orderamount": "Numero di ordine",
        "earnings": "Guadagni",
        "withdrawalsrecord": "Registro dei prelievi",
        "accounts": "Account",
        "accounttype": "Tipo dell'account",
        "withdrawalamount": "Numero di prelievo",
        "cancel": "Cancella",
        "submit": "Invia",

        "greaterthan": "L'importo deve essere maggiore di 30!",
        "normal": "Normale",
        "invalid": "Non valido",
        "bankcard": "Carta bancaria",
        "promotionlink": "Link promozionale",
        "discountcode": "Codice sconto",
        "waitingforapproval": "In attesa di approvazione",
        "waitingforpayment": "In attesa di pagamento",
        "notpass": "Non superare",
        "paid": "Pagato",

        "cashwithdrawalid": "Prelievo contanti ID",
        "accountsreceivable": "Conto disponibile",
        "amount": "Quantità(USD)",
        "status": "Stato",
        "applicationtime": "Tempo di applicazione",
        "processingresults": "Risultato di elaborazione",

        "orderid": "Numero d'ordine",
        "useramount": "Quantità di utente",
        "duration": "durata",
        "promotiontype": "Tipo di promozione",
        "createtime": "Tempo di creazione",
        "eainings": "Guadagni(USD)",

        "receivingaccount": "Conto disponibile",
        "nowithdrawableamount": "Nessun importo prelevabile",
        "copysuccessfully": "Copia con successo",
        "copyfailed": "Copia fallito",
        "salesvolume":"Sales Volume",
        "nodata":"No data available at the moment"
    },
    home: {
        'notice': 'Click getNfcode to get the solution to Netflix unable to log in',
        'join': 'Aderire',
        "texttitle": "Apri il tuo abbonamento condiviso a un prezzo inferiore",
        "buynow": "Acquista adesso",
        "soldout": "Prodotto esaurito",
        "delivery": "Consegna in tempo reale",
        "after": "Consegna in tempo reale dopo il pagamento senza attese",
        "certificate": "Certificato SSl",
        "payments": "I pagamenti vengono effettuati in un ambiente protetto con certificati di sicurezza ssl",
        "onlinesupport": "24/7 support online",
        "privatecustomer": "24/7 servizio cliente privato online",
        "subscriber": "Il coabbonato giusto",
        "subscriptions": "Condividi gli abbonamenti premium a un prezzo inferiore. Corrispondenza prioritaria per coabbonati dello stesso paese/area geografica",
        "moneyback": "Garanzia di rimborso",
        "refund": "Hai 1-20 giorni per richiedere un rimborso,Si prega di leggere la nostra politica di rimborso per i dettagli",
        "parkingspace": "slot",
        "gift": "ragalo",
        "screen": "Schermo",
        "1screen": "1 schermo",
        "maxnum": "massimo",
        "month": "Mese",
        "buytyp": "Tipo di acquisto",
        "subscription": "abbonamento",
        "voucher": "codice di riscatto",
        "discountcode": "Codice sconto",
        "use": "Usa",
        "paymentmethod": "metodo di pagamento",
        "pleasechoose": "Scegli",
        "billingdetails": "Dettagli di fatturazione",
        "payaddress": "Informazioni sull'indirizzo di pagamento",
        "firstname": "Nome",
        "lastname": "Cognome",
        "emailaddress": "Indirizzo email",
        "phone": "Numero di telefono",
        "country": "Paese/Regione",
        "state": "Stato",
        "city": "Città",
        "address": "indirizzo",
        "housenumber": "Numero civico e numero della via",
        "suiteunit": "Apartamento, casa, unità, ecc. (selezionato)",
        "zipcode": "cap",
        "submit": "Invia",
        "creditcard": "Carta di credito",
        "cardnumber": "Nunero di carta",
        "expirydate": "data di scudato",
        "nameoncard": "nome sulla carta",
        "savethiscard": "Conserva questa carta per pagamenti futuri",
        "play": "Paga",
        "emailerror": "Email errato",
        "payresluttitle": "Pagamento successo",
        "Pleaseconfirmsuk": "Si prega di confermare le informazioni sul prodotto",
        "buytips": "Tutti i nostri abbonamenti sono condivisi e venduti come account di condivisione, assicurati di averlo compreso prima dell'acquisto.",
        "pleaseenter": "Entra",
        "selectamonth": "Seleziona un mese",
        "selectthenumber": "Si prega di selezionare il numero di schermi",
        "selectthepurchase": "Si prega di selezionare il tipo di acquisto",
        "selectthepayment": "Si prega di selezionare il metodo di pagamento",
        "discountcodenotempty": "Il codice sconto non può essere vuoto!",
        "detail1": "<p><i class=\"el-icon-check\"></i><span>Piano Premium</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>5 persone condividono 1 abbonamento</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Mobile, PC, TV</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>4K, HDR, Dolby</span></p>",
        "detail2": "<p><i class=\"el-icon-check\"></i><span>Piano Premium</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Suono ad alta fedeltà</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Consegna dal vivo</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Mobile, PC, Tab</span></p>\n" +
            "<div id=\"gtx-trans\" style=\"position: absolute; left: 110px; top: 77.3906px;\">\n" +
            "<div class=\"gtx-trans-icon\">&nbsp;</div>\n" +
            "</div>",
        "detail3": "<p><i class=\"el-icon-check\"></i><span>Piano Premium</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>6 persone condividono 1 abbonamento,</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Mobile, PC, TV</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Profilo personale e storico</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Mantieni tutti i preferiti e gli elenchi</span></p>",
        "detail5": "<p><i class=\"el-icon-check\"></i><span>Piano Premium</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Invia link di invito in tempo reale</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Abbonamento personale, mantieni tutti i preferiti e gli elenchi</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Garanzia di rimborso Guarantee</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Nota: prima dell'acquisto, controlla su play.google.com se il paese del tuo account è ES, FR, PL, IT, DE, NL, GB, CA, US, JP, GR, CH, LT, PA, SG , CZ, SE, PT, BE, IL.</span> </p>\n" +
            "<div id=\"gtx-trans\" style=\"position: absolute; left: -51px; top: 143.094px;\">\n" +
            "<div class=\"gtx-trans-icon\">&nbsp;</div>\n" +
            "</div>",
        "detail7": "<p><i class=\"el-icon-check\"></i><span>Rinnova lo stesso abbonamento</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Mantieni tutti i preferiti e gli elenchi</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Consegna dal vivo</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Prima dell'acquisto, aprire il seguente collegamento per vedere se è possibile utilizzare max https://www.max.com/</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Garanzia di rimborso Guarantee</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Condividi l'abbonamento. Solo visualizzare su 1 schermo (1/4) Per ulteriori informazioni</span></p>",
        "detail8": "<p><i class=\"el-icon-check\"></i><span>ChatGPT Plus 4.0</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Goditi GPTs</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Disponibile per inserito</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Proibisce API</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Le condizioni della chat del modello 4.0 sono illimitate</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Il contenuto della chat è protetto e non può essere visualizzato da altri.</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Supporta post-vendita,24 ore rimborso senza preoccupazioni</span></p>",
        "detail9": "<p><i class=\"el-icon-check\"></i><span>Piano premium</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Consegna in tempo reale</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Supporta terminale mobile, PC, TV, TV box</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>4K, HDR, Dolby</span></p>",
        "detail10": "<p><i class=\"el-icon-check\"></i><span>Piano premium</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Invia link di invito in tempo reale</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Abbonamento privato, tieni tutto</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>I tuoi preferiti e le tue liste</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Garanzia, garanzia di rimborso</span></p>",
        "detail11": "<p><i class=\"el-icon-check\"></i><span>Account separato</span></p >\n" +
            "<p><i class=\"el-icon-check\"></i><span>Un account che può essere utilizzato da una sola persona</span></p >\n" +
            "<p><i class=\"el-icon-check\"></i><span>Abbonamento privato, mantieni tutto</span></p >\n" +
            "<p><i class=\"el-icon-check\"></i><span>Non si effettuato dalle policy di Netflix</span></p >\n" +
            "<p><i class=\"el-icon-check\"></i><span>Non ha bisogno alcun codice di verifica</span></p >",
        "detail12": "<p><i class=\"el-icon-check\"></i><span>Non è richiesto alcun account ChatGPT</span></p >\n" +
            "<p><i class=\"el-icon-check\"></i><span>Messaggi di chat protetti</span></p >\n" +
            "<p><i class=\"el-icon-check\"></i><span>Supporta GPT-4o e GPT-4o-mini</span></p >\n" +
            "<p><i class=\"el-icon-check\"></i><span>Supporta GPT-4.1, GPT-4.5, GPT-o3</span></p >\n" +
            "<p><i class=\"el-icon-check\"></i><span>Server ad alte prestazioni garantiscono un accesso stabile</span></p >",
        "detail13":
            "<p><i class=\"el-icon-check\"></i><span>Piano Education Plus (escluso Notion AI)</p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Libertà modulare: elimina la confusione dovuta all'uso di strumenti</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Workspace integrato: risparmia il 57% del costo degli strumenti</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Collaborazione in tempo reale: coordinamento della richiesta senza ritardo</span></p>",
         "detail14":
            "<p><i class=\"el-icon-check\"></i><span>Enjoy Super Duolingo</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>I membri possono godere di un ambiente di apprendimento senza pubblicità, evitando distrazioni durante ciascuna lezione e focalizzandosi sullo studio</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Utilizza la funzione 'Practice Personalizzata' per correggere gli errori durante l'esercizio</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>I membri possono sfidare il livello leggendario più alto all'infinito, padroneggiare in modo approfondito i contenuti appresi e migliorare le proprie competenze linguistiche.</span></p>",
        "lowerpricesharelarge":"Share premium subscription services at a lower price on",
        "lowerpricesharesmall":"Share premium subscription services at a lower price on <span class='green-text-2'>AlongShare</span>",
        "highqualitystreaming":"Providing high-quality and reasonably priced streaming services for 5 consecutive years",
        "detail":"Detail",
        "moreactivities":"More activities, more rewards",
        "sharejoinsubscription":"<span class='green-text-2'>Share</span>Join Subscription",
        "shareyoursubscription":"Share your subscription",
        "availabletime":"Make full use of the available time slots on your subscription.",
        "makemoney":"Make money and save up to 80% of subscription fees every month.",
        "widerangesubscription":"A wide range of subscription sharing options can help you earn more income.",
        "threestepsshare":"Just three steps to share! Too simple!",
        "joinsubscription":"Join subscription",
        "saveupsubscriptionfees":"Save up to 80% of subscription fees every month.",
        "securepayment":"Secure payment ensures your financial security.",
        "manualreview":"Manual review ensures the authenticity and validity of subscriptions.",
        "oneclickjoin":"One click join!",
        "whyusealongshare":"Why are<span class='green-text-2'> more and more</span> people using<span class='green-text-2'> Alongshare</span>",
        "position":"{0} Position",
        "selectdiscount":"Select Discount",
        "notstoreinfo":"AlongShare does not store your bank card information. All transactions are protected, processed, and authorized by external payment providers.",
        "alumpsum":"A Lump Sum",
        "details":"Details",
        "subtotal":"Subtotal",
        "promotioncodescoupons":"Promotion Codes&Coupons",
        "paymentfee":"Payment Fee",
        "total":"Total",
        "nowastediscount":"Don't waste this discount!",
        "hoursjoin":"Si è unito {hours} ore fa",
        "minutesjoin":"Si è unito {minutes} minuti fa"
    },
    login: {
        "welcomelogin": "Benvenuto in Accedi",
        "login": "Accedi",
        "updatepwd": "Cambia la password",
        "reg": "Account registrato",
        "agreement": "Dichiari di aver letto e accettato i nostri termini e condizioni. Leggi la nostra Politica sulla riservatezza per scoprire come vengono trattati i tuoi dati",
        "quicklogin": "Accedi subito",
        "sendcode": "Invia il codice",
        "register": "Registra",
        "changepassword": "Cambia la password",
        "verificationcode": "Codice di verifica",
        "name": "Nome",
        "password": "Password",
        "agapassword": "Ripete Password",
        "modify": "Modifica",
        //"validatepswlen":"La password soddisfa lettere maiuscole e minuscole, numeri e caratteri speciali, qualsiasi combinazione di tre di essi e la lunghezza è compresa tra 8 e 16!",
        "validatepswlen": "La password deve contenere lettere, numeri o caratteri speciali",
        "checkagreement": "Si prega di controllare l'accordo",
        "passwordinconsistency": "Le password inserite due volte sono incoerenti!",
        "passwordagain": "si prega di inserire nuovamente la password",
        "verificationsend": "Il codice di verifica è stato inviato, prestare attenzione al controllo",
        "useemail": "Or use your email address",
        "agree": "Continuing means that you agree to our",
        "and": "and",
        "andconfirm": "and confirm",
        "readour": "You have read our",
        "forgotpassword": "Forgot Password",
        "codelogin": "Login with verification code",
        "verifyemail": "Verify Email",
        "sendcodeemail": "We will send the verification code via email to the input verification completed registration {email}.",
        "continue": "continue",
        "resend": "Resend",
        "noreceivecode": "Can't receive the verification code?",
        "passwordlogin": "Password login",
        "setpassword": "Set Password",
        "confirmpassword": "Confirm Password"
    },
    luckdraw: {
        "lotteryticket": "Lotteria",
        "integral": "Punti accumulati",
        "welcome": "Benvenuto su Alongshare, questa è la nostra pagina delle attività, fai clic sulla carta per ottenere premi con un clic, i premi includono vari account gratuiti, codici sconto e altri sconti, grazie per il tuo supporto e fiducia.",
        "none": "non esiste",
        "redemptioncode": "codice di riscatto",
        "copy": "copia",
        "prizelist": "lista di premio",
        "notused": "non usato",
        "used": "usato",
        "expired": "scaduto",

        "prizeno": "Numero",
        "contents": "Contento",
        "exchangedate": "Data di scambio",
        "createtime": "Date di creazione",
        "exchange": "Scambio",
        "insufficientpoints": "Punti insufficienti",
        "consumepoints": "Questa operazione consumerà 10 punti. Continua?",
        "tips": "Tips",
        "comfirm": "Conferma",
        "cancel": "Cancella",
        "failtowin": "Impossibile ottenere un premio",
        "congratulations": "Congratulazioni per aver ottenuto",
        "copysucceeded": "Copia con successo!",
        "copyfailed": "Copia fallito!",

    },
    subscribe: {
        "clickto": "Click to get link.",
        "Resend": "Have you already sent a new code back? Get it again",
        "getverificationlink": " Get login verification link",
        "getlinktips": "If you have not been asked to fill in the verification code,please ignorethis feature.",
        "renewnow": "Rinnova adesso",
        "subscription": "Rinnova lo stesso abbonamento senza modifiche",
        "independent": "4K+HDR HD, registrazione di visualizzazione indipendente",
        "guarantee": "garanzia di rimborso",
        "timeleft": "Tempo rimasto",
        "openingtime": "Tempo di inizio dell'account",
        "endtime": "Tempo scaduto",
        "account": "Account",
        "password": "Password",
        "profile": "profilo",
        "pleaseuse": "Si prega di utilizzare",
        "subaccount": "sub account",
        "myprofile": "Il mio profilo è utilizzato in modo improprio da qualcuno!",
        "renew": "Rinnovo",
        "aftersales": "Dopovendita",

        "submitYoutube": 'Copia il collegamento e aprilo nel browser con l account con cui desideri iscriverti',
        "yourownsub": "1.Utilizzare il proprio sub account in base al numero di serie",
        "delete": "2.Non modificare/eliminare sub account",
        "modifysubscription": "3.Non modificare le informazioni relative all'abbonamento",
        "reminder": "Nota: In caso di problemi, contatta il servizio clienti in tempo, acquista un abbonamento su Alongshare, goditi il servizio clienti VIP e non è necessario modificare il numero per il rinnovo.",

        "youtubeloginemail": "Inserisci la tua email di accesso a YouTube. È necessario utilizzare l'indirizzo e-mail inserito per unirti al gruppo familiare.\n" +
            "                                               Altrimenti verrai espulso dalla famiglia. Se hai bisogno di aiuto, contatta il servizio clienti nell'angolo in basso a destra.",
        "aftersalesservice": "Servizio dopovendita",
        "support": "Pagina di supporto",
        "submit": "Invia",

        "buyit": "Non ci sono ancora abbonamento, vai ad acquistarlo",
        "paymentsucceeded": "Pagamento riuscito",
        "month": "Seleziona un mese",
        "number": "Seleziona il numero di schermi",
        "purchase": "Seleziona il tipo di acquisto",
        "payment": "Seleziona il metodo di pagamento",
        "name": "Inserisci il nome sulla carta",
        "card": "Inserisci il numero della carta",
        "cvv": "Inserisci CVV",
        "expirydate": "Inserisci la data di scadenza",
        "processing": "Lo stato di elaborazione è stato inviato. Controlla lo stato di elaborazione dell'ordine di lavoro.",
        "cannotempty": "Il codice sconto non può essere vuoto!",
        "originalpassword": "La password originale per questa operazione non verrà più utilizzata, vuoi continuare?",
        "passwordmeets": "La password deve contenere lettere maiuscole e minuscole, numeri e caratteri speciali, qualsiasi combinazione di tre di essi, e la lunghezza è compresa tra 8 e 16!"
    },
    userinfo: {
        "signout": "Esci",
        "nickname": "Soprannome",
        "avatar": "Avatar",
        "uploadavatar": "Per favore carica il tuo avatar",
        "logout": "Sei sicuro di voler uscire?",
        "onlyjpgpng": "Le immagini caricate possono essere solo in formato JPG | formato png",
        "cannotexceed": "La dimensione dell'immagine caricata non può superare i 5 MB!",
        "exitalongshare":"Exit AlongShare?",
        "personaldata":"Personal Data",
        "clickimage":"Click on the image to edit",
        "edit":"Edit",
        "alongshareloginemail":"AlongShare Login Email",
        "save":"Save",
        "resetpassword":"Reset Password",
        "editpassword":"Edit Password",
        "passwordmust":"Your password must have",
        "anycharacter":"Any letter, number, special character",
        "twosamepasswords":"The two passwords you entered are the same",
        "currentpassword":"Current Password",
        "newpassword":"New Password",
        "confirmpassword":"Confirm password",
        "updatepassword":"Update Password"
    },
    wish: {
        "wish": "Desiderio",
        "help": "AlongShare sceglierà alcuni desideri per eseguire",
        "christmas": "si avverano quando arriva Natale, lascia il tuo desiderio",
        "submit": "Invia",
        "mywish": "Il mio desiderio"
    },
    map: {
        "home": "Pagina iniziale",
        "userinfo": "Informazioni dell'utente",
        "login": "Accedi",
        "withfriends": "con amici",
        "subscribe": "Abbonamento",
        "aftersales": "Dopovendita",
        "luckdraw": "Sorteggio fortunato",
        "wish": "Desiderio",
        "helpcenter": "Centro di aiuto",
        "tradingstamps": "Lista di riscatto",
        "order": "Order"
    },
    order: {
        "whetherpayment":"Whether to make payment or not",
        "yes":"Yes",
        "no":"No"
    }
}

export default it
